import { StatusBadge } from '@components/ui';
import React from 'react';
import { useIntl } from 'react-intl';
import type { ColumnWithLooseAccessor, ColumnWithStrictAccessor } from 'react-table';
import type { IMyWorkspaceItem } from 'types/workspace.types';

type TColumn =
  | ColumnWithLooseAccessor<IMyWorkspaceItem>
  | ColumnWithStrictAccessor<IMyWorkspaceItem>;

export function useTableColumns() {
  const { formatMessage } = useIntl();

  return React.useMemo<TColumn[]>(
    () => [
      {
        Header: formatMessage({ id: 'departments_table_title' }),
        id: 'name',
        accessor: 'name',
      } as ColumnWithStrictAccessor<IMyWorkspaceItem>,
      {
        Header: formatMessage({ id: 'departments_table_institution' }),
        accessor: 'institutionName',
        Cell: ({ row }) => <>{row.original.institutionName ?? '-'}</>,
      } as ColumnWithStrictAccessor<IMyWorkspaceItem>,
      {
        Header: 'Adresa',
        id: 'address',
        Cell: ({ row: { original } }) => {
          return <>{`${original.address}, ${original.postCode} ${original.city}`}</>;
        },
      } as ColumnWithLooseAccessor<IMyWorkspaceItem>,
      {
        Header: 'Expertíza',
        id: 'expertise',
        Cell: ({ row }) =>
          row.original.expertise ? (
            <>{`${row.original.expertise.name} (${row.original.expertise.code})`}</>
          ) : (
            <>-</>
          ),
      } as ColumnWithLooseAccessor<IMyWorkspaceItem>,
      {
        Header: 'Má e-Termíny',
        id: 'e-visit',
        Cell: ({ row }) =>
          row.original.hasEvisit ? (
            <StatusBadge label="Áno" variant="success" size="medium" />
          ) : (
            <StatusBadge label="Nie" variant="danger" size="medium" />
          ),
      } as ColumnWithLooseAccessor<IMyWorkspaceItem>,
      // { id: 'actions' },
    ],
    [formatMessage],
  );
}
